<template>
<div v-tooltip="tooltip">
  <router-link v-if="to" :to="to">
    <navbar-info :title="formattedTitle" :info="formattedAmount" />
  </router-link>
  <navbar-info :title="formattedTitle" :info="formattedAmount" v-else />
</div>
</template>

<script>
import NavbarInfo from '@/components/navbar/navbar-info'
import numeral from 'numeral'

export default {
  components: {
    NavbarInfo
  },
  computed: {
    formattedAmount () {
      return numeral(this.amount).format('0.00a')
    },
    formattedTitle () {
      return `${this.symbol} ${this.title}`
    },
    tooltip () {
      return `${this.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} ${this.symbol}`
    }
  },
  props: {
    symbol: {
      type: String,
      required: false,
      default: 'HVT'
    },
    title: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true,
      default: 0
    },
    to: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.title.is-primary {
  color: $primary;
  font-weight: bold;
}
.subtitle.is-white {
  color: white;
}

.title.is-6 {
  font-size: 14px;
}
.subtitle.is-6 {
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/balance.vue